import { EditorState, Modifier } from '@wix/draft-js';
/**
 * Simply adds the code to the editor, this will be processed
 * by the decorator then.
 */
export default function addOfficialEmote(editorState, code) {
    // Create the new entity with metadata
    var contentState = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var contentStateWithInsertedText = Modifier.replaceText(contentState, selection, code + " ", null, null);
    var nextEditorState = EditorState.push(editorState, contentStateWithInsertedText, 'insert-official-emote');
    return nextEditorState;
}
//# sourceMappingURL=add-official-emote.js.map